import { enumOrRaw } from '~/services/api/contracts/enumOrRaw'
import {
  MenuAvailabilityModeSchema,
  MenuAvailabilitySchema,
  MenuStatusSchema
} from '~/services/api/generated'
import { Normalization } from '~/utils/normalization'

export const normalizeMenuSchedule = (input: Record<string, unknown>): Record<string, unknown> => {
  const next: Record<string, unknown> = { ...input }
  const schedule = Normalization.listOfAssocArrays(next['schedule'])
  if (!Array.isArray(next['custom_hours']) && schedule.length > 0) {
    next['custom_hours'] = schedule.map((entry) => ({
      ...entry,
      is_enabled: entry['is_enabled'] ?? true
    }))
  }
  if ('status' in next) next['status'] = enumOrRaw(next['status'], MenuStatusSchema.options)
  if ('availability' in next)
    next['availability'] = enumOrRaw(next['availability'], MenuAvailabilitySchema.options)
  if ('availability_mode' in next) {
    next['availability_mode'] = enumOrRaw(
      next['availability_mode'],
      MenuAvailabilityModeSchema.options
    )
  }
  return next
}
